import React, { Component } from "react";
import data from "../data/profile.json";

class Profile extends Component {
    constructor(props) {
        super(props);
        this.prop = {
            profile: data[0].basics,
            social: data[1].social,
            skills: data[2].skills
        };
    }

    renderSocialMedia() {
        const data = this.prop.social;
        return data.map((item, index) => {
            return <a className="social-link" key={index} href={item.url}>{item.network} {item.usename}</a>
        });
    }

    renderSkills() {
        const data = this.prop.skills;
        return data.map((item, index) => {
            return <li className="badge" key={index}>{item}</li>
        });
    }

    render() {
        const profile = this.prop.profile;
        return (
            <section className="container profile">
                <span id="profile" className="anchor" role="presentation"></span>
                <div className="heading-container">
                    <div className="col">
                        <h2 className="heading">Profile</h2>
                        <h3 className="heading-highlight">{profile.firstname} {profile.lastname}</h3>
                        <p className="lead">{this.prop.profile.label}</p>
                    </div>
                    <div className="col contact">
                        <p className="profile-contact">
                            <span>{profile.phone}</span><br/>
                            <span><a href={"mailto:" + profile.email}>{profile.email}</a></span><br/>
                        </p>
                        <div className="profile-social">
                            {this.renderSocialMedia()}
                        </div>
                    </div>
                </div>
                <article className="content-container">
                    <p className="lead">{profile.summary}</p>
                    <h4>Skills:</h4>
                    <ul className="profile-skills">
                        {this.renderSkills()}
                    </ul>
                </article>
            </section>
        )
    }
}

export default Profile;


// WEBPACK FOOTER //
// ./src/components/profile.js